<footer>
  <div class="copyright">
    <p>Copyright © Designed & Developed by <a href="#">Univa Health</a> 2024</p>
  </div>
</footer>
